<template>
    <van-popup v-model:show="show" position="bottom" :overlay-style="{ overflow: 'hidden' }" :style="{
        minWidth: '100%',
        height: '70%',
        color: '#FFF',
    }" class="addressPopup">
        <div class="network_container">
            <div class="popTitle">{{ $t('withdraw.chooseNetwork') }}</div>
            <div v-for="(item, index) in networkList" :key="index">
                <network-card :channel="item?.channel" :channelName="item?.channelName" @click="selectNetwork(item)"
                    :instructions="item?.instructions" />
            </div>
        </div>

    </van-popup>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import NetworkCard from './networkCard.vue';
import { NetworkChannelItem } from '@/view/withdraw/supportScript';
const props = defineProps<{
    networkList: NetworkChannelItem[]
}>()
const emits = defineEmits(['selectNetwork'])
const show = ref(false);

const openPopup = () => {
    show.value = true;
}

const closePopup = () => {
    show.value = false;
}

const selectNetwork = (network: any) => {
    emits('selectNetwork', network)
}

defineExpose({
    openPopup,
    closePopup
})
</script>
<style scoped>
.addressPopup {
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    /* border: 0.5px solid #046ACC !important; */
    /* background: #1A223A !important; */
    opacity: 0.8 !important;
    background: #090F1F !important;
    box-shadow: inset 0px -3px 0px 0px #014b89, inset 0px 3px 0px 0px #014b89;
}

::-webkit-scrollbar {
    display: none;
}

.van-overlay {
    backdrop-filter: blur(5px);
}

.network_container {
    padding: 15px 15px 85px;
}

.popTitle {
    font-size: 18px;
    display: flex;
    text-align: center;
    justify-content: center;
    padding: 16px;
    color: #FFF;
    font-weight: bold;
}
</style>